import React, { ReactElement } from 'react';

import { OverviewTile, Title, HeroText } from './HeaderTileStyles';

interface TileProps {
    title: string;
    text?: string;
    children?: React.ReactNode;
}

const HeaderTile = (props: TileProps): ReactElement => {
    return (
        <OverviewTile>
            <Title>{props.title}</Title>
            <HeroText>
                {props.text}
            </HeroText>
        </OverviewTile>
    );
};

export default HeaderTile;
